import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
    Box, Typography, Tabs, Tab, Paper
} from '@mui/material';
import {
    People as PeopleIcon,
    ReceiptLong as SplitIcon,
    AccountBalance as BalanceIcon
} from '@mui/icons-material';

// Import existing page components as sections
import FriendsSection from '../components/split/FriendsSection';
import SplitExpensesSection from '../components/split/SplitExpensesSection';
import BalancesSection from '../components/split/BalancesSection';

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`split-tabpanel-${index}`}
            aria-labelledby={`split-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function SplitHub() {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');
    
    // Map tab names to indices
    const tabMap = {
        'friends': 0,
        'expenses': 1,
        'balances': 2
    };
    
    const [activeTab, setActiveTab] = useState(tabMap[tabParam] ?? 0);

    useEffect(() => {
        // Update tab from URL parameter
        if (tabParam && tabMap[tabParam] !== undefined) {
            setActiveTab(tabMap[tabParam]);
        }
    }, [tabParam]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        // Update URL parameter
        const tabNames = ['friends', 'expenses', 'balances'];
        setSearchParams({ tab: tabNames[newValue] });
    };

    return (
        <Box>
            <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
                Split & Settle
            </Typography>

            <Paper sx={{ mb: 3 }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .MuiTab-root': {
                            minHeight: 64,
                            textTransform: 'none',
                            fontSize: '1rem',
                        }
                    }}
                >
                    <Tab 
                        icon={<PeopleIcon />} 
                        label="Friends & Groups" 
                        iconPosition="start"
                    />
                    <Tab 
                        icon={<SplitIcon />} 
                        label="Split Expenses" 
                        iconPosition="start"
                    />
                    <Tab 
                        icon={<BalanceIcon />} 
                        label="Balances" 
                        iconPosition="start"
                    />
                </Tabs>
            </Paper>

            <TabPanel value={activeTab} index={0}>
                <FriendsSection />
            </TabPanel>

            <TabPanel value={activeTab} index={1}>
                <SplitExpensesSection />
            </TabPanel>

            <TabPanel value={activeTab} index={2}>
                <BalancesSection />
            </TabPanel>
        </Box>
    );
}

export default SplitHub;

